/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Big_Lime_Felix_JoltInputs */

const fr_big_lime_felix_jolt = /** @type {(inputs: Big_Lime_Felix_JoltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`packs`)
};

/**

* @param {Big_Lime_Felix_JoltInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const big_lime_felix_jolt = /** @type {((inputs?: Big_Lime_Felix_JoltInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Big_Lime_Felix_JoltInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_big_lime_felix_jolt(inputs)
});